import { Component, OnInit } from '@angular/core';
import { AppServerAPI } from '@sdbn/common';
import { AbstractWidgetComponent } from '@sdbn/common';
import { ContextChange } from '@sdbn/common';
import { Message } from '../../send-message.model';
import { DialogService } from '@sdbn/common';
import { Transport } from '../../../../../common/model/transport.model';

@Component({
    selector: 'app-send-message-dialog',
    templateUrl: './send-message-dialog.component.html',
    styleUrls: ['./send-message-dialog.component.scss'],
    standalone: false
})
export class SendMessageDialogComponent extends AbstractWidgetComponent implements OnInit {

  messages = new Array<Message>();

  selected: Message;

  transport: Transport;

  transportHasMessaging = false;

  constructor(
    private appServerAPI: AppServerAPI,
    private dialogService: DialogService,
  ) {
    super();
  }

  ngOnInit(): void {

    this.appServerAPI.execute<Array<Message>>('/client/control/send-message/getAllMessages', {}).subscribe(
      messages => {
        const result = new Array<Message>();
        for (const message of messages) {
          result.push(new Message(message));
        }
        this.messages = result;
      }
    );

  }

  onContextChange(contextChange: ContextChange) {
    if (contextChange.key === 'selected-transport') {
      this.transport = contextChange.value;
      this.transportHasMessaging = this.transport != null && this.transport.messaging.messagingAvailable;
    }
  }


  onSetElementAndContext() {
    this.transport = this.dashboardContext.getContextValue('selected-transport');
    this.transportHasMessaging = this.transport != null && this.transport.messaging.messagingAvailable;
  }

  selectMessage(message: Message) {
    console.log('selectMessage', message);
    this.selected = message;
  }

  sendMessageAllTransports() {

    this.dialogService.showConfirm('tmc-yard.ui.send-message.confirm.all-transports.title', 'tmc-yard.ui.send-message.confirm.all-transports.message').afterClosed().subscribe(confirmed => {
      if (confirmed) {

        this.appServerAPI.execute<Array<Message>>('/client/control/send-message/sendMessageAllTransports', { messageId: this.selected.id }).subscribe(
          response => {

          }
        );
      }
    });

  }

  sendMessageAllTransportsOnYard() {
    this.dialogService.showConfirm('tmc-yard.ui.send-message.confirm.all-transports-on-yard.title', 'tmc-yard.ui.send-message.confirm.all-transports-on-yard.message').afterClosed().subscribe(confirmed => {
      if (confirmed) {

        this.appServerAPI.execute<Array<Message>>('/client/control/send-message/sendMessageAllTransportsOnYard', { messageId: this.selected.id }).subscribe(
          response => {

          }
        );
      }
    });
  }

  sendMessageCurrentTransport() {

    this.appServerAPI.execute<Array<Message>>('/client/control/send-message/sendMessage', { messageId: this.selected.id, transportId: this.transport.id }).subscribe(
      response => {

      }
    );
  }

}
